<template>
  <div>
    <common-header title="설문조사" :showTitle="true" :showCart="false" :showHome="false" :showBack="false"/>
    <main class="survey_q_bg">
      <div class="header">
        <h4>{{this.fetchedSelectGuestSurvey.survey.surveyName}}</h4>
      </div>
      <div class="content" >{{this.fetchedSelectGuestSurvey.survey.content}}</div>
      <div>
        <button type="button" class="btn btn-full btn-primary footer-bottom" @click="changeSurveyQuestionView">설문조사 시작</button>
      </div>
    </main>
  </div>
</template>

<script>
import {AppConfig} from '@/config/AppConfig';
import {mapActions, mapGetters, mapMutations} from "vuex";
import {YN} from "../AppConstants";

export default {
  data() {
    return {
      orderNo : null,
    }
  },
  created() {

    // 설문조사 조회
    const orderNo = this.$route.params.orderNo;
    this.orderNo = orderNo;

    // 검증 여부 초기화
    this.SET_VALIDATE_YN(YN.N);

    this.showLoading(true);
    this.SELECT_GUEST_SURVEY(orderNo)
      .then(response => {
        if (response.code !== '0000') {
          this.showAlert(response.message);
        }else{
          if(this.fetchedSelectGuestSurvey.answerYn === 'Y' && this.fetchedSelectGuestSurvey.surveyBenefitHistories.length > 0){
            window.location.href = AppConfig.VUE_APP_DOMAIN + 'gp_gift/accept.jsp?item_type=CPN&item_no='+this.fetchedSelectGuestSurvey.surveyBenefitHistories[0].couponNo;
          }
        }
      })
    .catch(error => this.showAlert("설문조사 조회에 실패했습니다."))
    .finally(() => this.showLoading(false))


  },
  computed: {
    ...mapGetters(['fetchedSelectGuestSurvey', 'fetchedSurveyAnswerYn'])
  },
  methods: {
    ...mapMutations(['SET_VALIDATE_YN']),
    ...mapActions(['SELECT_GUEST_SURVEY', 'FETCH_GUEST_VALIDATE_YN']),
    changeSurveyQuestionView() {

      // 설문조사 답변 가능 여부 검증
      this.showLoading(true);
      this.FETCH_GUEST_VALIDATE_YN(this.fetchedSelectGuestSurvey.surveyMemberId)
        .then(response => {
          if (response.code === '0000') {
            // 설문조사 질문으로 이동
            this.$router.push(`/surveyGuest/${this.fetchedSelectGuestSurvey.survey.surveyId}/questions/${this.orderNo}/${this.fetchedSelectGuestSurvey.surveyMemberId}`);
          } else {
            this.showAlert(response.message);
          }
        })
        .catch(error => this.showAlert("설문조사 답변 가능 여부 검증에 실패했습니다."))
        .finally(() => this.showLoading(false))
    },
    lineChange(txt){
      if(txt.length > 0){
        return txt.replaceAll("\n","<br/>");
      }else{
        return "";
      }

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/survey/SurveyGuest.vue